import { Component, OnInit, Input, Output, OnChanges, EventEmitter } from '@angular/core';
import { FormGroup, FormArray, AbstractControl } from '@angular/forms';

import { JssTreeObject } from '../../model/jss-tree-object';
import { JssNodeAbstract } from '../../model/jss-tree-abstract';
import { JssNodeLeaf } from '../../model/jss-tree-leaf';

@Component({
   selector: 'app-json-form-root',
   templateUrl: './json-form-root.component.html',
   styleUrls: ['./json-form-root.component.scss']
})
export class JsonFormComponent implements OnInit, OnChanges {

   // public to access in template directly
   public _children: JssNodeAbstract[] = null;
   public _nodeName: string = null;
   public _nodeType: string = null;
   public _title: string = null;
   public _supressSubmitEvent = false;
   public hasFocus = false;
   public _formGroup: FormGroup | FormArray = null;

   // input
   @Input() jssTreeObject: JssTreeObject = null;
   @Input('cancelButton') _cancelButton = true;
   @Input('submitButton') _submitButton = true;
   @Input('applyButton') _applyButton = false;
   @Input('readonly') _readonly = false;

   // events
   @Output() cancelEvent = new EventEmitter();
   @Output() submitEvent = new EventEmitter<any>();
   @Output() applyEvent = new EventEmitter<any>();

   constructor() { }
   ngOnInit() { }

   ngOnChanges() {
      if (this.jssTreeObject) {
         this._nodeName = this.jssTreeObject.nodeName;
         this._nodeType = this.jssTreeObject.nodeType;
         this._children = this.jssTreeObject.children;
         this._formGroup = this.jssTreeObject.formGroup;

         // title
         if (this.jssTreeObject.showTitle) {
            this._title = this.jssTreeObject.hasTitle() ? this.jssTreeObject.title : this._nodeName;
         }

         // activate submit event
         this._supressSubmitEvent = false;
      }
   }

   // -- Events from JsonForm -------------------
   public onCancel(): void {
      this.jssTreeObject = null;
      this._supressSubmitEvent = true;
      this.cancelEvent.emit();
   }
   public onSubmit(formValue: any): void {
      // HINT: anomalie: onSubmit function is beeing called after onCancel was applied!
      if (!this._supressSubmitEvent) {
         this.submitEvent.emit(formValue);
      }
   }
   public onApply(formValue: any): void {
      // HINT: anomalie: onSubmit function is beeing called after onCancel was applied!
      if (!this._supressSubmitEvent) {
         this.applyEvent.emit(formValue);
      }
   }

   public doBlur(elem: HTMLElement): void {
      elem.blur();
   }

   public hasEnabledChilds(node: JssNodeAbstract): boolean {
      switch (node.nodeType) {
         case 'OBJECT':
         case 'LAYOUT':
            for (const child of node.children) {
               if (this.hasEnabledChilds(child)) {
                  return true;
               }
            }
            break;
         default:
            if (node instanceof JssNodeLeaf) {
               return !node.valuePassThrough && node.enabled;
            }
            return node.enabled;
      }
   }

   public displayButtons(): boolean {
      return this.hasEnabledChilds(this.jssTreeObject) && !this._readonly;
   }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/json-form/material/json-form-root/json-form-root.component.ts